import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
    COMFORT_CHIP_OPTIONS,
    ComfortAnswers,
    emptyComfortAnswers,
} from '../../../model/ai-comfort.model';

/**
 * Questionnaire confort / accessibilité (onboarding IA).
 * Les réponses sont émises au parent pour persistance sur Lilate / Elate.
 */
@Component({
    selector: 'lib-ai-exam-onboarding-comfort',
    standalone: true,
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './AI-exam-onboarding-comfort.component.html',
    styleUrls: ['./AI-exam-onboarding-comfort.component.scss'],
})
export class AIExamOnboardingComfortComponent {
    @Output() back = new EventEmitter<void>();
    @Output() continue = new EventEmitter<ComfortAnswers>();
    @Output() skip = new EventEmitter<void>();

    readonly chips = COMFORT_CHIP_OPTIONS;
    selectedChips = signal<Set<string>>(new Set());
    freeText = signal('');

    toggleChip(id: string): void {
        this.selectedChips.update((set) => {
            const next = new Set(set);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    }

    isSelected(id: string): boolean {
        return this.selectedChips().has(id);
    }

    onFreeTextChange(value: string): void {
        this.freeText.set(value);
    }

    onContinue(): void {
        this.continue.emit(this.collectAnswers());
    }

    private collectAnswers(): ComfortAnswers {
        return {
            chips: Array.from(this.selectedChips()),
            details: this.freeText().trim() || null,
        };
    }
}

export type { ComfortAnswers };
export { emptyComfortAnswers };
